import { AuthenticationModuleClient } from 'external-modules/authentication/client';

const Login = () => {
  return <AuthenticationModuleClient.LoginPage />;
};

export default Login;
